import AvailabilityNotificationPopup from 'containers/MapDetails/popups/AvailabilityNotificationPopup'
import { addItemToBasket, BASKET_TYPES, extendFormToMap } from 'containers/OrderDetails/basketSlice'
import { selectPlaceData, selectPlaceStatus } from 'containers/MapDetails/placeSlice'
import useFreshPlaceData from 'containers/MapDetails/hooks/useFreshPlaceData'
import { checkIsAvailableForRentInFuture } from 'containers/MapDetails/utils'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import DetailsPopup from 'containers/MapDetails/popups/DetailsPopup'
import MagElement from 'containers/MapDetails/MagElement'
import RentButton from 'containers/MapDetails/RentButton'
import { useDispatch, useSelector } from 'react-redux'
import useTranslation from 'hooks/useTranslation'
import usePopupState from 'hooks/usePopupState'
import { displayPrice } from 'utils/string'
import { useEffect, useState } from 'react'
import htbox1 from 'assets/img/htbox1.png'
import Loading from 'components/Loading'
import { STATUS } from 'utils/constants'
import { useReduxSelector } from 'store'
import { selectConfig } from 'appSlice'
import { v7 } from 'uuid'
import './style.scss'

const type = process.env.REACT_APP_TYPE

const ObjectMags = () => {
  const { warehouses, sizes: allSizes, sizeGroups, displayOptions, ...place } = useSelector(selectPlaceData)
  const [selectedGroupId, selectGroupId] = useState(sizeGroups?.[0]?.warehouseSizeGroupId)
  const { placeId: placeIdParams } = useParams()
  const status = useSelector(selectPlaceStatus)
  const config = useReduxSelector(selectConfig)
  const { popup, openPopup } = usePopupState()
  const { state } = useLocation()

  useFreshPlaceData()
  const dispatch = useDispatch()
  const { push, replace } = useHistory()
  const { t } = useTranslation('mapDetails')

  const sizes = allSizes?.filter(size => size.rentableType !== 'parking')
  const succeed = status === STATUS.succeed
  const group = selectedGroupId && sizeGroups
    ? sizeGroups.find(group => group.warehouseSizeGroupId === selectedGroupId)
    : undefined

  useEffect(() => {
    if (sizeGroups && sizeGroups.length > 0 && !selectedGroupId) {
      selectGroupId(sizeGroups?.[0]?.warehouseSizeGroupId)
    }
  }, [selectedGroupId, sizeGroups])

  useEffect(() => {
    const isUnlocked = (state && typeof state === 'object' && 'unlock' in state) ? state.unlock : undefined
    if (isUnlocked) {
      replace(window.location.pathname + window.location.search)
    }
  }, [replace, state])

  // const szukaneWarehouseTypeId = ''
  // const { selectedWarehouseType, restSizes } = sizes?.reduce((r, size) => {
  //   if (size.warehouseTypeId === szukaneWarehouseTypeId) {
  //     r.selectedWarehouseType = size
  //   } else {
  //     r.restSizes.push(size)
  //   }
  //   return r
  // }, { restSizes: [] })

  const addToBasketOrShowNextPage = (data, hash, date) => {
    if (!config) return
    if (config?.blockedCart) {
      openPopup('blockedCart')

    } else if (!data?.isRental && (displayOptions?.showMap || displayOptions?.listAllWarehouses)) {
      push(`/placemap/${placeIdParams}?warehouseTypeId=${data.data.warehouseTypeId}${hash ? `&hash=${hash}` : ''}`)

    } else {
      const identifier = v7()
      const id = Object.keys(data.for_rent || {})?.[0]
      const details = data?.isRental && id
        ? { id }
        : { hash }

      dispatch(
        addItemToBasket({
          ...details,
          identifier,
          type: BASKET_TYPES.rent,
          object: data?.data?.object,
          minDate: date ? date.replace(/(\d{2})\.(\d{2})\.(\d{4})/, '$3-$2-$1') : undefined,
          image: data?.warehouseAnimation === 'custom' && (data?.warehouseTransparentPhoto || data?.warehousePhoto)
            ? (data.warehouseTransparentPhoto || data.warehousePhoto)
            : sizes.find(size => size.warehouseTypeId === data?.data?.warehouseTypeId)?.renders?.default,
          hasOnlineAccess: data?.data?.hasOnlineAccess,
          rentableType: data?.rentableType,
          name: data.warehouseTypeName,
          placeId: placeIdParams,
        })
      )
      push(`/order/${identifier}`)
      dispatch(extendFormToMap(false))
    }
  }


  return (
    <div className='objectMags'>
      {popup?.type === 'details' && <DetailsPopup
        count={popup.body?.count}
        data={popup.body?.details}
      />}
      {popup?.type === 'availability' && <AvailabilityNotificationPopup
        placeId={placeIdParams}
        companyName={place.companyName}
        groupHash={popup.body?.groupHash}
        variantHash={popup.body?.variantHash}
        name={popup.body?.name}
      />}
      <div className='objectMags__list'>
        {succeed && sizes && warehouses
          ? sizeGroups && sizeGroups.length > 0
            ? <div className='objectMags__group'>
              <div className='objectMags__group__header'>
                <div className='objectMags__group__header__menu'>
                  {sizeGroups.map(group => <button
                    id={group.warehouseSizeGroupId}
                    key={group.warehouseSizeGroupId}
                    className={`button${group.warehouseSizeGroupId === selectedGroupId ? ' --selected' : ''}`}
                    onClick={() => {
                      if (group.warehouseSizeGroupId === selectedGroupId) return
                      selectGroupId(group.warehouseSizeGroupId)
                    }}>
                    {group.name} ({group.areaMinShortName} - {group.areaMaxShortName})
                  </button>)}
                </div>
                <div className='objectMags__group__header__main'>
                  <div className='objectMags__group__header__img'>
                    <img
                      alt='warehouse preview'
                      src={group?.image || htbox1}
                    />
                  </div>
                  <div className='objectMags__group__header__content'>
                    {(group?.fits && group.fits.length > 0) && <div className='objectMags__size__right__size'>
                      <h4>{t('youCanFitItHere')}:</h4>
                      <div>
                        {group.fits.map(({ name }, fitIdx) => (
                          <div key={fitIdx} className='element'>
                            <i className='icon icon--checkbox'></i>
                            <span>{name}</span>
                          </div>
                        ))}
                      </div>
                    </div>}
                  </div>
                </div>
              </div>
              <p>{t('selectSize')}</p>
              <div className='objectMags__mags'>
                {group?.warehouseTypeIds?.map(id => {
                  return Object.entries(warehouses?.[id] || {})
                    .sort(([, a], [, b]) => a.order - b.order)
                    .map(([hash, data]) => (
                      <MagElement
                        isDesktop
                        key={hash}
                        data={data}
                        showSizes
                        openPopup={(type) => {
                          if (type === 'details') {
                            openPopup({ type: 'details', body: { details: data?.details, count: data?.free_now_to_rent_count } })
                          } else if (type === 'availability') {
                            openPopup({ type: 'availability', body: { name: `${data?.warehouseTypeName} - ${data?.name}`, groupHash: id, variantHash: hash } })
                          }
                        }}
                        action={(date) => {
                          addToBasketOrShowNextPage(data, hash, date)
                        }}
                      />
                    ))
                })}
              </div>
            </div>
            : sizes.map((item, idx) => {
              const currentWarehouses = warehouses[item.warehouseTypeId] || null
              const warehouseEntries = currentWarehouses
                ? Object.entries(currentWarehouses).sort(([, a], [, b]) => a.order - b.order)
                : []
              const isOnlyOneChild = warehouseEntries.length === 1
              const firstHash = Object.keys(currentWarehouses)[0]
              const firstHashGroup = currentWarehouses[firstHash]
              const { showWarning } = checkIsAvailableForRentInFuture(firstHashGroup?.isAvailableForRentNow, firstHashGroup?.for_rent)

              return (
                <div key={idx} className='objectMags__size'>
                  <div className='objectMags__size__top'>
                    <div className='objectMags__size__left'>
                      <div className='objectMags__size__left__head --secFont'>
                        <span>{item.name}</span>
                        {item.size && <span>{item.size} m<sup>2</sup></span>}
                      </div>
                      <div className='objectMags__size__left__img'>
                        <img
                          src={item.renders?.default}
                          alt='Warehouse'
                        />
                      </div>
                    </div>
                    <div className='objectMags__size__right'>
                      <div className='objectMags__size__right__top'>
                        {isOnlyOneChild && firstHashGroup?.attrs?.some(attr => !attr.isImportant) && <div className='objectMags__size__right__attrs'>
                          <h4>{t('storageFeatures')}</h4>
                          <div>
                            {firstHashGroup?.attrs?.map(({ key, name, isImportant }) => {
                              if (isImportant) return null
                              return <div
                                key={key}
                                className='item'>
                                <i className={`icon icon--${key}-bold`} />
                                {name}
                              </div>
                            })}
                          </div>
                        </div>}

                        {(item.internalLength || item.internalWidth || item.internalHeight) && <div className='objectMags__size__right__dimensions__wrapper'>
                          <h4>{t('internalDimensions')}</h4>
                          <div className='objectMags__size__right__dimensions'>
                            <div className='objectMags__size__right__dimension'>
                              <i className='icon icon--length' />
                              <span>{t('length-short')}: {Number(item.internalLength)}m</span>
                            </div>
                            <div className='objectMags__size__right__dimension'>
                              <i className='icon icon--width' />
                              <span>{t('width-short')}: {Number(item.internalWidth)}m</span>
                            </div>
                            <div className='objectMags__size__right__dimension'>
                              <i className='icon icon--height' />
                              <span>{t('height-short')}: {Number(item.internalHeight)}m</span>
                            </div>
                          </div>
                        </div>}

                        {type !== 'chr01' && (item.doorWidth || item.doorHeight) && <div className='objectMags__size__right__dimensions__wrapper'>
                          <h4>{t('doorDimensions')}</h4>
                          <div className='objectMags__size__right__dimensions'>
                            <div className='objectMags__size__right__dimension'>
                              <i className='icon icon--length' />
                              <span>{t('width-short')}: {Number(item.doorWidth)}m</span>
                            </div>
                            <div className='objectMags__size__right__dimension'>
                              <i className='icon icon--width' />
                              <span>{t('height-short')}: {Number(item.doorHeight)}m</span>
                            </div>
                          </div>
                        </div>}

                        {item.fits && item.fits.length > 0 && <div className='objectMags__size__right__size'>
                          <h4>{t('youCanFitItHere')}:</h4>
                          <div>
                            {item.fits.map(({ name }, fitIdx) => (
                              <div key={fitIdx} className='element'>
                                <i className='icon icon--checkbox'></i>
                                <span>{name}</span>
                              </div>
                            ))}
                          </div>
                        </div>}

                        {showWarning && <div className='objectMags__size__right__warning'>
                          {t('lastItemInReservation')}
                        </div>}
                      </div>
                      {warehouseEntries.length === 1 && <div className='objectMags__size__extraButtons'>
                        <div className='objectMags__size__price__wrapper'>
                          <div className='objectMags__size__price'>
                            <span className='--secFont'>{item.monthlyGrossPrice ? `${displayPrice(item.monthlyGrossPrice)}` : ''}</span>
                            <span>&nbsp;/&nbsp;{t('monthly')}</span>
                          </div>
                        </div>
                        <div className='objectMags__size__rightBtn'>
                          <RentButton
                            disabled={!firstHashGroup?.count}
                            for_rent={firstHashGroup?.for_rent}
                            isAvailableForRentNow={firstHashGroup?.isAvailableForRentNow}
                            rent={(date) => {
                              if (date) addToBasketOrShowNextPage(firstHashGroup, firstHash, date)
                              else addToBasketOrShowNextPage(firstHashGroup, firstHash)
                            }}
                            openAvailabilityPopup={() => {
                              openPopup({ type: 'availability', body: { name: `${firstHashGroup?.warehouseTypeName} - ${firstHashGroup?.name}`, groupHash: item.warehouseTypeId, variantHash: firstHash } })
                            }}
                          />
                        </div>
                      </div>}
                    </div>
                  </div>

                  {warehouseEntries.length > 1
                    ? <div className='objectMags__mags'>
                      {warehouseEntries.map(([hash, data]) => (
                        <MagElement
                          isDesktop
                          key={hash}
                          data={data}
                          openPopup={(type) => {
                            if (type === 'details') {
                              openPopup({ type: 'details', body: { details: data?.details, count: data?.free_now_to_rent_count } })
                            } else if (type === 'availability') {
                              openPopup({ type: 'availability', body: { name: `${data?.warehouseTypeName} - ${data?.name}`, groupHash: item.warehouseTypeId, variantHash: hash } })
                            }
                          }}
                          action={(date) => {
                            addToBasketOrShowNextPage(data, hash, date)
                          }}
                        />
                      ))}
                    </div>
                    : <div className='objectMags__size__bottom'>
                      <div className='objectMags__size__price__wrapper'>
                        <div className='objectMags__size__price'>
                          <span className='--secFont'>{item.monthlyGrossPrice ? `${displayPrice(item.monthlyGrossPrice)}` : ''}</span>
                          <span>&nbsp;/&nbsp;{t('monthly')}</span>
                        </div>
                      </div>
                      <div className='objectMags__size__rightBtn'>
                        <RentButton
                          disabled={!firstHashGroup?.count}
                          for_rent={firstHashGroup?.for_rent}
                          isAvailableForRentNow={firstHashGroup?.isAvailableForRentNow}
                          rent={(date) => {
                            if (date) addToBasketOrShowNextPage(firstHashGroup, firstHash, date)
                            else addToBasketOrShowNextPage(firstHashGroup, firstHash)
                          }}
                          openAvailabilityPopup={() => {
                            openPopup({ type: 'availability', body: { name: `${firstHashGroup?.warehouseTypeName} - ${firstHashGroup?.name}`, groupHash: item.warehouseTypeId, variantHash: firstHash } })
                          }}
                        />
                      </div>
                    </div>}
                </div>
              )
            })
          : <Loading middleOfPage />}
      </div>
    </div>
  )
}

export default ObjectMags
